/** 身分 */
export enum Identity {
  /** 訪客 */
  VISITOR = '0',
  /** 差旅人 */
  TRAVELER = '1',
  /** 差旅經理人(主管理者) */
  MAIN_MANAGER = '2',
  /** 差旅經理人(副管理者) */
  DEPUTY_MANAGER = '3',
  /** 差旅經理人(代理人) */
  AGENT = '4',
  /** MICE */
  MICE = '5',
  /** 企業帳號 */
  CORPORATE_ACCOUNT = '6',
  /** 企業子帳號 */
  CORPORATE_SUB_ACCOUNT = '7'
}
